var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_11560_30920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "#D1EDC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0.193359C18.5205 0.193359 23.8066 5.47948 23.8066 12C23.8066 18.5205 18.5205 23.8066 12 23.8066C5.47948 23.8066 0.193359 18.5205 0.193359 12C0.193359 5.47948 5.47948 0.193359 12 0.193359Z",
    stroke: "#C5EBB3",
    strokeWidth: 0.387097
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11560_30920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 7.16016C11.865 7.16016 11.7346 7.20828 11.6321 7.29586C10.7902 8.03134 9.58052 8.61199 8.61278 8.61199C8.48445 8.61199 8.36137 8.66297 8.27063 8.75371C8.17989 8.84445 8.12891 8.96753 8.12891 9.09586V12.483C8.12891 14.9023 9.82245 16.112 11.8402 16.8088C11.9445 16.8476 12.059 16.8493 12.1644 16.8136C14.1773 16.112 15.8708 14.9023 15.8708 12.483V9.09586C15.8708 8.96753 15.8199 8.84445 15.7291 8.75371C15.6384 8.66297 15.5153 8.61199 15.387 8.61199C14.4192 8.61199 13.2144 8.03618 12.3676 7.29586C12.2651 7.20828 12.1347 7.16016 11.9999 7.16016ZM11.9999 7.16016V16.8378",
    stroke: "#2B731E",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_11560_30920",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.93548
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.586317 0 0 0 0 0.884413 0 0 0 0 0.570627 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11560_30920"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11560_30920"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.6129,
    height: 11.6129,
    fill: "white",
    transform: "translate(6.19336 6.19336)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityIcon);
export default __webpack_public_path__ + "static/media/security_icon.57a4e0ec7b1870a7f38cb8acd801b6bf.svg";
export { ForwardRef as ReactComponent };